import { jsx as _jsx } from "preact/jsx-runtime";
import { useState, useEffect, useContext } from 'preact/hooks';
import { SDKContext } from '../context';
import { useIsMouMobile } from '../utils/responsive';
/**
 * Checkbox component for User Selected Perks (USP) functionality
 */
export function USPCheckbox({ offer, settings, apiPayload, onSelectionChange, isSelected: propIsSelected, }) {
    const ctx = useContext(SDKContext);
    const isMobile = useIsMouMobile();
    const [isSelected, setIsSelected] = useState(propIsSelected || false);
    // Don't render if USP is not enabled
    if (!settings.enable_user_selected_perks ||
        !settings.enable_usp ||
        !apiPayload?.pub_user_id) {
        return null;
    }
    useEffect(() => {
        if (propIsSelected !== undefined) {
            setIsSelected(propIsSelected);
        }
    }, [propIsSelected]);
    useEffect(() => {
        const sdk = ctx?.sdk;
        if (!sdk)
            return;
        if (settings.usp_all_offers_checked && !sdk.reused_session) {
            setIsSelected(true);
        }
    }, [settings.usp_all_offers_checked, ctx]);
    const handleCheckboxChange = (e) => {
        e.stopPropagation();
        const target = e.target;
        const newIsSelected = target.checked;
        setIsSelected(newIsSelected);
        onSelectionChange(offer.campaign_id ?? offer.id, newIsSelected);
        // Persist via legacy AdpxUtils when available, sourcing state from the
        // per-instance SDK rather than the global window.Adpx singleton.
        const AdpxUtils = window.AdpxUtils;
        if (AdpxUtils?.storage?.saveSelectedOffers && ctx) {
            const { sdk } = ctx;
            AdpxUtils.storage.saveSelectedOffers(sdk.mouState.selectedOffers, sdk.getPayload(), settings);
        }
    };
    const checkboxId = `adpx-checkbox-${offer.id}`;
    const checkboxStyles = {
        position: 'absolute',
        right: '8px',
        top: isMobile ? '4px' : '10px',
        width: '16px',
        height: '16px',
        cursor: 'pointer',
        accentColor: '#007bff',
    };
    return (_jsx("input", { type: 'checkbox', id: checkboxId, className: 'adpx-mou_checkbox', style: checkboxStyles, checked: isSelected, onChange: handleCheckboxChange, onClick: e => e.stopPropagation() }));
}
